// VARIAVEIS GLOBAIS
// VARIAVEIS GLOBAIS
// VARIAVEIS GLOBAIS

// ###########################################################################################################

var globals = {
  REACT_APP_APIAMIGO: process.env.REACT_APP_APIAMIGO,
  REACT_APP_ENDERECO: process.env.REACT_APP_ENDERECO,
  REACT_APP_COPA_API: process.env.REACT_APP_COPA_API,
};
export default globals;

// ###########################################################################################################
